import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router.js'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import VueResource from 'vue-resource';

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || "";

Vue.use(VueResource);
Vue.http.options.root = apiBaseUrl;
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading);
let currentlyRuningAjaxRequests = 0;

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  },

  mounted() {
    let loader;
    Vue.http.interceptors.push((request, next) => {
      if (currentlyRuningAjaxRequests === 0) {
        loader = this.$loading.show();
      }
      currentlyRuningAjaxRequests++;
      request.headers.set('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
      request.headers.set('Accept', 'application/json');
      next((response) => {
        currentlyRuningAjaxRequests--;
        if (currentlyRuningAjaxRequests === 0) {
          loader.hide();
        }
        if (response.status === 401) {
          
          // desi se kod dva concurrent ajax zahtjeva da ga s logina jos jednom redirecta na login, pa dobije dupli nexturl
          let isCurrentRouteLoginPage = this.$router.currentRoute.name === "UserLogin";

          if (!isCurrentRouteLoginPage) {
            let nextURl = encodeURIComponent(this.$router.currentRoute.path);
            this.$router.push({ path: "/user/login/" + nextURl });
          }
        }
      });
    })
  }
});

